<template>
  <div class="layout flex-wrap">
    <div class="flex xs12 sm6 lg4" v-for="item in items" :key="item.id">
      <div class="news-item">
        <router-link :to="`/news/${item.id}`" class="news-image" :style="{ backgroundImage: `url(${item.image})` }"></router-link>
        <div class="news-content">
          <div class="layout pt-3">
            <div class="cate">{{ item.category?.text }}</div>
            <div class="date">{{ $moment(item.date).format("LL") }}</div>
          </div>
          <div class="news-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss">
.news-item {
  padding: 12px;
  .news-image {
    display: block;
    cursor: pointer;
    padding-top: 65%;
    background-size: cover;
    background-position: center;
    border-bottom: solid 10px var(--background-red);
  }
  .news-content {
    font-size: 14px;
    line-height: 28px;
    .cate {
      color: var(--background-red);
      margin-right: 24px;
    }
    .date {
      color: #7d7d7d;
    }
    .news-title {
      font-weight: bold;
      font-size: 24px;
      line-height: 2;
    }
  }
}
</style>
